// Eigenbau: Unified-Diff-Anzeige; Tremor bietet keinen Diff-Baustein und eine
// Diff-Bibliothek wäre für eine klassifizierte Zeilenliste zu schwer.
import { zerlegeDiff } from "@cubic/shared";
import { cx } from "@/lib/utils";

/**
 * Zeigt einen Unified-Diff zeilenweise mit Hinzufügen-/Entfernen-Farben.
 * Die Zeilenklassifikation kommt aus `@cubic/shared` (zerlegeDiff) — die
 * Oberfläche baut keine Diff-Syntax nach.
 */
export function DiffAnsicht({ diff }: { diff: string }) {
  const zeilen = zerlegeDiff(diff);
  if (zeilen.length === 0) {
    return (
      <p className="text-sm text-gray-500">
        Keine Diff-Zeilen — binäre oder sehr große Datei.
      </p>
    );
  }
  return (
    <pre
      className="overflow-x-auto rounded-lg bg-gray-100 p-3 text-xs leading-5 dark:bg-gray-950"
      role="region"
      aria-label="Datei-Diff"
    >
      {zeilen.map((zeile, index) => (
        <div
          key={index}
          className={cx(
            zeile.art === "hinzugefuegt" &&
              "bg-emerald-50 text-emerald-900 dark:bg-emerald-500/10 dark:text-emerald-300",
            zeile.art === "entfernt" &&
              "bg-rose-50 text-rose-900 dark:bg-rose-500/10 dark:text-rose-300",
            zeile.art === "kopf" && "text-gray-400 dark:text-gray-600",
            zeile.art === "kontext" && "text-gray-700 dark:text-gray-300",
          )}
        >
          {zeile.text || " "}
        </div>
      ))}
    </pre>
  );
}
